import React from 'react';
import { connect } from 'react-redux';
import { jsx, css } from '@emotion/core';
import { primary_s20_l95 } from '../../shared/lib/colors';

import './ProductAutocomplete.scss';
import { ImageDispatcher } from '../ImageDispatcher/ImageDispatcher';

const ProductAutocomplete = ({
  innerRef,
  innerProps,
  product,
  primaryColor,
  isDoofinder,
}) => {
  const style = css`
    &:hover {
      background-color: ${primary_s20_l95(primaryColor)};
    }
  `;

  return (
    <div
      className="product-autocomplete"
      ref={innerRef}
      {...innerProps}
      css={style}
    >
      {product.searchKeywords ? (
        product.sponsor ? (
          <div
            style={{
              display: 'flex',
              backgroundColor: product.backgroundColor,
              alignItems: 'center',
              justifyContent: 'flex-end',
              color: 'white',
              paddingRight: 8,
            }}
          >
            <i style={{ paddingRight: 4 }}>{product.label}</i>
            <span style={{ fontWeight: 'bold', fontSize: 16 }}>
              <i>{product.sponsorName}</i>
            </span>
          </div>
        ) : (
          <div className="vedi-tutti" style={{ color: primaryColor }}>
            Vedi tutti &raquo;
          </div>
        )
      ) : (
        <div
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <div
            style={{
              flex: 1,
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              gap: '1.5rem',
            }}
          >
            <div style={{ position: 'relative' }}>
              <ImageDispatcher
                id={`img_product_${product.id}`}
                src={product.image}
                alt="Immagine prodotto cercato"
                className="img-fluid"
                style={{ width: 48, height: 48, objectFit: 'contain' }}
              />

              {product.price &&
                product.listPrice &&
                product.price < product.listPrice && (
                  <div
                    style={{
                      position: 'absolute',
                      top: -8,
                      right: -14,
                      width: 24,
                      height: 24,
                      borderRadius: 50,
                      backgroundColor: primaryColor,
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textAlign: 'center',
                      fontSize: 10,
                      zIndex: 1000,
                    }}
                  >
                    {(
                      100 -
                      (product.price * 100) / Number(product.listPrice)
                    ).toFixed(0) + '%'}
                  </div>
                )}
            </div>
            <div style={{ flex: isDoofinder ? 3 : 5 }}>{product.name}</div>
          </div>
          {/* {isDoofinder && product.price && ( */}
          {!!product.price && (
            <div
              style={{
                flex: 1,
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'flex-end',
                flexDirection: 'column',
              }}
            >
              {product.listPrice && (
                <div style={{ textDecoration: 'line-through' }}>
                  {'€ ' + product.listPrice}
                </div>
              )}
              <div style={{ fontWeight: 'bold' }}>{'€ ' + product.price}</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  primaryColor: state.store.data.loghiTemplate.brandColor,
});

export default connect(mapStateToProps)(ProductAutocomplete);
